module.exports = __webpack_public_path__ + "media/images/sr_register01-d91e429c.svg";